import { Icon } from '@iconify/react';
import type { HostListItem } from '@/types/communityHost';
import { formatMonthYear } from './hostFormat';

interface HostListProps {
  hosts: HostListItem[];
  onOpenActions: (host: HostListItem) => void;
}

export function HostList({ hosts, onOpenActions }: HostListProps) {
  return (
    <div className="bg-white rounded-2xl border border-[#E0E6ED] shadow-2xs overflow-hidden divide-y divide-gray-100">
      {hosts.map((host) => {
        const isOwner = host.kind === 'owner';
        const sinceLabel = formatMonthYear(host.since);
        const subtitle = isOwner ? `Owner · sejak ${sinceLabel}` : `Co-host sejak ${sinceLabel}`;

        return (
          <div key={host.community_user_id} className="px-4 py-3.5 flex items-center gap-3">
            <div className="flex-1 min-w-0">
              <p className="text-sm font-extrabold text-[#0E1726] truncate">{host.name}</p>
              <p className="text-xs text-gray-400 font-medium mt-0.5 truncate">{subtitle}</p>
            </div>
            <span
              className={`shrink-0 text-[11px] font-bold px-2.5 py-1 rounded-full ${
                isOwner ? 'bg-orange-50 text-[#FC480D]' : 'bg-blue-50 text-blue-600'
              }`}
            >
              {isOwner ? 'Owner' : 'Co-Host'}
            </span>
            <button
              type="button"
              onClick={() => onOpenActions(host)}
              className="shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:bg-gray-50 cursor-pointer"
              aria-label={`Aksi ${host.name}`}
            >
              <Icon icon="ph:dots-three-vertical-bold" className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
